var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarTickOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8265 8.048L11.8842 7.2L7.54647 11.104L5.66203 9.408L4.7198 10.256L7.54647 12.8L12.8265 8.048ZM15.022 1.6H14.1331V0H12.3554V1.6H5.24425V0H3.46647V1.6H2.57758C1.59092 1.6 0.808694 2.32 0.808694 3.2L0.799805 14.4C0.799805 15.28 1.59092 16 2.57758 16H15.022C15.9998 16 16.7998 15.28 16.7998 14.4V3.2C16.7998 2.32 15.9998 1.6 15.022 1.6ZM15.022 14.4H2.57758V5.6H15.022V14.4Z",
    fill: "#FF8B51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTickOrange);
export default __webpack_public_path__ + "static/media/calendar-tick-orange.572c1f9a537bbfeca6f3fe665feffde6.svg";
export { ForwardRef as ReactComponent };